<template>
    <Modal >
        <div class="astreinte-container">
            <div class="titre-container">
                <p>
                    {{$t('modale.jour.ferie.titre')}}
                </p>
            </div>
            <div v-for='societeAstreinte in societesJourFerie' :key='societeAstreinte.societe'>
                <div class="text">
                    {{ societeAstreinte.societe }}
                </div>
                <div class="text">
                    {{ societeAstreinte.telephone }}
                </div>
            </div>
            <img class="close-icon" @click="cancel" :src="closeIcon" alt="close" />
        </div>
    </Modal>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import Modal from '@/components/ui-components/Modal.vue';
import { CoordonneesAstreinte } from '@/modules/Intervention/store/state';

export default defineComponent({
    components: { Modal, },
    computed: {
        closeIcon(): void {
            return require('@/assets/img/close-black.svg');
        },
        societesJourFerie(): CoordonneesAstreinte[] {
            return this.$store.getters.getCoordonneesJourFerie;
        },
    },
    methods: {
        cancel(): void{
            this.$emit('cancel');
        }
    },
});
</script>

<style scoped>
.astreinte-container{
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 375px;
    background-color: var(--white);
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14),
    0 1px 5px rgba(0, 0, 0, 0.12);
    text-align: center;
    font-weight: 500;
    font-size: var(--font-size-low-medium);
    color: var(--color-principal);
    padding: 16px;
    gap: 8px;
}
.close-icon {
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
}
.titre-container {
    margin: 15px;
    font-size: var(--font-size-low-large);
}
.text {
    margin: 5px;
}
</style>
